/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import EditPatientDataContent from "components/content/EditPatientDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

/**
 * Patient profile editing page.
 * Allows modification of existing patient demographic and medical information.
 * 
 * Features:
 * - Edit patient demographics and contact information
 * - Update insurance information
 * - Modify emergency contacts
 * - Update medical history and allergies
 * - Form validation with error handling
 * - Integration with patient management system
 * - Audit trail of profile changes
 * 
 * The page receives patientId via:
 * - Navigation state from patient list or hub page, or
 * - URL parameter for direct access
 * 
 * @returns {JSX.Element} Edit patient page component
 */
const EditPatientPage: FC = () => {
  const { state } = useLocation();
  const { patientId } = state;

  let { id } = useParams();

  const idResult = useMemo<string>(() => patientId || id, [patientId, id]);

  console.log(id);

  return (
    <DefaultDashboardLayout>
      <EditPatientDataContent patientId={idResult} />
    </DefaultDashboardLayout>
  );
};

export default EditPatientPage;

